import { useTranslation } from "react-i18next";
import Appointment from "../HomeMain/Appointment";
import Bredcrumb from "../HomeMain/Bredcrumb";
import SalonMap from "../ui/SalonMap";

const Main = () => {
  const { t } = useTranslation();

  return (
    <>
      <Bredcrumb title={t('pages.contact.title')} subtitle={t('pages.contact.subtitle')} />
      <Appointment />

      <div className="map fix" style={{ background: "#F5F5F5" }}>
        <div className="container-flud">
          <div className="row">
            <div className="col-lg-12">
              <SalonMap title={t('contact.mapTitle')} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Main;
